require('angular');
require('./angular-scroll');

module.exports = 'duScroll';



//////////////////
// WEBPACK FOOTER
// ../~/angular-scroll/index.js
// module id = 334
// module chunks = 0